module.exports = __webpack_public_path__ + "static/media/Alexissmall.779a3f5f.jpg";